<template>
  <EXTooltip
    v-if="tooltipTitle"
    placement="top"
    :delay="300"
    :title="tooltipTitle"
    show-on-child-focus
  >
    <span
      class="pay-range-corrected-badge"
      tabindex="0"
      @click.stop
      @keydown.stop
    >
      Corrected
    </span>
  </EXTooltip>
  <span v-else class="pay-range-corrected-badge">Corrected</span>
</template>

<script setup>
import { computed } from "vue";

import EXTooltip from "@components/tooltip/EXTooltip.vue";
import { formatFairPayDate } from "@components/utils/fairPayFormat";

const props = defineProps({
  /** ISO date / datetime the version was corrected (`corrected_at`). */
  correctedAt: {
    type: [String, Date],
    default: null,
  },
  /** Resolved display name of who corrected it. */
  correctedByName: {
    type: String,
    default: "",
  },
});

const tooltipTitle = computed(() => {
  const date = formatFairPayDate(props.correctedAt);
  if (!date) return "";
  return `Corrected ${date} by ${props.correctedByName || "another user"}`;
});
</script>

<style scoped>
.pay-range-corrected-badge {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 2px 8px;
  border: 1px solid #d6bbfb;
  border-radius: 9999px;
  background: #ffffff;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #6941c6;
  white-space: nowrap;
}

.pay-range-corrected-badge:focus-visible {
  outline: 2px solid #7f56d9;
  outline-offset: 2px;
}
</style>
